import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { AlertTriangle, Home, ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/Button';

export const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-[80vh] flex items-center justify-center">
      <Helmet>
        <title>Page non trouvée - DPEWizard</title>
        <meta name="description" content="La page que vous recherchez n'existe pas. Retournez à l'accueil ou explorez nos services d'analyse DPE." />
      </Helmet>
      
      <div className="text-center max-w-md mx-auto p-6">
        <div className="w-20 h-20 bg-yellow-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <AlertTriangle className="w-10 h-10 text-yellow-600" />
        </div>
        
        <h1 className="text-4xl font-bold text-gray-900 mb-4">404</h1>
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">Page non trouvée</h2>
        
        <p className="text-gray-600 mb-8">
          La page que vous recherchez n'existe pas ou a été déplacée.
          Veuillez vérifier l'URL ou retourner à la page d'accueil.
        </p>
        
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Button
            variant="outline"
            onClick={() => navigate(-1)}
            icon={<ArrowLeft className="w-4 h-4 mr-2" />}
          >
            Retour
          </Button>
          
          <Button
            variant="primary"
            onClick={() => navigate('/')}
            icon={<Home className="w-4 h-4 mr-2" />}
          >
            Accueil
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;